module.exports = __webpack_public_path__ + "static/media/logging.b0a360f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logging.svg
// module id = 397
// module chunks = 0